var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseSquare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11,0 C11.5522847,-1.01453063e-16 12,0.44771525 12,1 L12,11 C12,11.5522847 11.5522847,12 11,12 L1,12 C0.44771525,12 6.76353751e-17,11.5522847 0,11 L0,1 C-6.76353751e-17,0.44771525 0.44771525,1.01453063e-16 1,0 L11,0 Z M3.87868681,3.17157413 L3.17158003,3.87868091 C2.97822692,4.07203402 2.97823071,4.39243837 3.17158003,4.58578769 L4.58579359,6.00000125 L3.17158003,7.41421481 C2.97822481,7.60757003 2.97823282,7.92797438 3.17158003,8.1213216 L3.87868681,8.82842838 C4.07203992,9.02178149 4.39243837,9.0217836 4.58579359,8.82842838 L6.00000715,7.41421481 L7.41422071,8.82842838 C7.60757593,9.0217836 7.92797438,9.02178149 8.1213275,8.82842838 L8.82843428,8.1213216 C9.02178149,7.92797438 9.0217895,7.60757003 8.82843428,7.41421481 L7.41422071,6.00000125 L8.82843428,4.58578769 C9.0217836,4.39243837 9.02178739,4.07203402 8.82843428,3.87868091 L8.1213275,3.17157413 C7.92798028,2.97822692 7.60757003,2.97822481 7.41422071,3.17157413 L6.00000715,4.58578769 L4.58579359,3.17157413 C4.39244427,2.97822481 4.07203402,2.97822692 3.87868681,3.17157413 Z",
    id: "x-close"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Close/Square"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "xmask",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x-close"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#000000",
    xlinkHref: "#x-close"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSquare);
export default __webpack_public_path__ + "static/media/close-square.33267d05b4ea7ecdd4167c59d3906b60.svg";
export { ForwardRef as ReactComponent };